import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Config } from 'ionic-angular';

import { CarpoolingOfferModel } from '../../app/models/carpooling-offer-model';

import { CarpoolingOffersService } from '../../providers/carpooling-offers-service/carpooling-offers-service';

@Injectable()
export class RestCarpoolingOffersService implements CarpoolingOffersService {
  private serverUrl : string;

  constructor(private http: Http, configuration: Config) {
    this.serverUrl = configuration.get('backendUrl');
  }

  public findOffersForEvent(eventCode : string) : Observable<CarpoolingOfferModel[]> {
    return Observable.create(observer => {
	  this.http.get(this.serverUrl+'/api/'+eventCode+'/carpooling/')
        .map(res => this.adaptFromRemoteCarpoolingOffers(res.json()))
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(error);
        });
    });
  }

  private adaptFromRemoteCarpoolingOffers(carpooling: any) : CarpoolingOfferModel[] {
    return null;//FIXME: real implementation
	}

  private handleError(error) {
    console.error(error);
    return Observable.throw((error.status === 404 ? error.text() : error.json().error) || 'Server error while reading news data');
  }

}




// WEBPACK FOOTER //
// ./src/providers/carpooling-offers-service/rest-carpooling-offers-service.ts